import { RouteConfig } from 'vue-router'

const Info = () => import('../views/user/Info.vue')

export const infoRoute: RouteConfig = {
  path: '/user/info',
  name: 'user_info',
  component: Info,
  props: (_route) => ({ ..._route.query, ..._route.params }),
  meta: {
    title: '信息示例',
  },
}

export default [infoRoute]
